import { css } from '@emotion/css';
import { observer } from 'mobx-react-lite';

import { SPACING, font2 } from '^/constants/commonStyles';
import CancellationAndRefundHertzPOD from '^/pages/Booking/components/DriverDetails/components/CancellationAndRefund/CancellationAndRefund.Hertz.POD';
import CancellationAndRefundHertzPPD from '^/pages/Booking/components/DriverDetails/components/CancellationAndRefund/CancellationAndRefund.Hertz.PPD';
import { getTermsAndConditionCancellationRichContent } from '^/pages/Booking/renewal/components/TermsAndConditions/TermsAndConditionCancellation.Rich';
import { getTermsAndConditionCancellationTumonContent } from '^/pages/Booking/renewal/components/TermsAndConditions/TermsAndConditionCancellation.Tumon';

import { ReservationDetailsPageViewModel } from '../ReservationDetailsPage.viewmodel';

import { ReservationDetailsBill } from './components/ReservationDetailDesktop.bill';
import { ReservationDetailsDriverInfo } from './components/ReservationDetailDesktop.DriverInfo';
import { ReservationDetailsVehicleScheduleInfo } from './components/ReservationDetailDesktop.VehicleScheduleInfo';
import { ReservationStatusBadge } from './ReservationStatusBadge';
import { getExtraChargeDisplayCurrency } from '../extraChargeDisplay';
import { Horizon } from '^/pages/ReservationList/components/common/Horizon';
import { getTermsAndConditionCancellationOrixContent } from '^/pages/Booking/renewal/components/TermsAndConditions/TermsAndConditionCancellation.Orix';
import { MustHaveBelongings } from '^/pages/Booking/renewal/components/DriverInfo/MustHaveBelongings';

export const ReservationDetailPageDesktop: React.FC<{
  viewmodel: ReservationDetailsPageViewModel;
  onClickCancelReservation: () => void;
}> = observer(function ReservationDetailPageDesktop({ viewmodel, onClickCancelReservation }) {
  const getCancellationTerms = () => {
    if (viewmodel.vendorId === 'RC') {
      return getTermsAndConditionCancellationRichContent();
    }
    if (viewmodel.vendorId === 'TM') {
      return getTermsAndConditionCancellationTumonContent();
    }
    if (
      viewmodel.reservationDetail.status === 'success' &&
      viewmodel.reservationDetail.value.pay_type === 'PPD'
    ) {
      if (viewmodel.vendorId === 'OR') {
        return getTermsAndConditionCancellationOrixContent({
          freeCancelDeadline: viewmodel.reservationDetail.value.free_cancel_deadline,
          cancelPolicy: viewmodel.reservationDetail.value.cancel_policy,
        });
      }
      return (
        <CancellationAndRefundHertzPPD
          cancelPolicy={viewmodel.reservationDetail.value.cancel_policy}
        />
      );
    }
    return <CancellationAndRefundHertzPOD />;
  };

  if (viewmodel.reservationDetail.status === 'success') {
    const extraChargeDisplayCurrency = getExtraChargeDisplayCurrency(
      viewmodel.reservationDetail.value.supplier,
    );
    return (
      <div
        id="ReservationDetailsPageDesktopRoot"
        className={[
          css`
            max-width: 1060px;
            height: 100%;
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            @media (max-width: 1280px) {
              padding-left: 24px;
              padding-right: 24px;
            }
            display: grid;
            gap: ${SPACING.spacing24};
            padding-top: 60px;
            grid-template-columns: 1fr max-content;
            grid-template-rows: 1fr min-content;
            grid-template-areas:
              'content floatingbill'
              'footer footer';
          `,
        ].join(' ')}
      >
        <div
          className={[
            css`
              grid-area: content;
            `,
          ].join(' ')}
        >
          <div
            className={css`
              display: flex;
              justify-content: space-between;
              width: 100%;
            `}
          >
            <h1 className={font2.Title1}>예약 내역 상세</h1>
            <ReservationStatusBadge status={viewmodel.reservationDetail.value.res_status} />
          </div>

          <h2
            className={[
              font2.Title3,
              css`
                margin-top: 30px;
              `,
            ].join(' ')}
          >
            차량 및 일정
          </h2>
          <ReservationDetailsVehicleScheduleInfo data={viewmodel.reservationDetail.value} />
          <Horizon marginTop="30px" marginBottom="30px" height="1px" />
          <h2
            className={[
              font2.Title3,
              css`
                margin-top: ${SPACING.spacing48};
              `,
            ].join(' ')}
          >
            운전자 정보
          </h2>
          <ReservationDetailsDriverInfo data={viewmodel.reservationDetail.value} />
          <Horizon marginTop="30px" marginBottom="30px" height="1px" />
          <MustHaveBelongings />
          <Horizon marginTop="30px" marginBottom="30px" height="1px" />

          <h2 className={font2.Title3}>취소 및 환불규정</h2>
          <div className="mt-4 rounded-[10px] bg-secondary-gray-light p-4 text-default font-light leading-5 mobile:text-small">
            {getCancellationTerms()}
          </div>
        </div>
        <div
          className={[
            css`
              position: sticky;
              top: 0px;
              height: fit-content;
              margin-bottom: 380px;
              grid-area: floatingbill;

              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 21px;
              background-color: #ffffff;
              border: 1px solid #d3d3d6;
              border-radius: 10px;
              padding: 24px;
              width: 387px;
            `,
          ].join(' ')}
        >
          <ReservationDetailsBill
            data={viewmodel.reservationDetail.value}
            extraChargeDisplayCurrency={extraChargeDisplayCurrency}
            onClickCancelReservation={() => {
              onClickCancelReservation();
            }}
          />
        </div>
      </div>
    );
  }

  return null;
});
